import Collapse from '@mui/material/Collapse';
import Typography from '@mui/material/Typography';
import { Translation } from '@ps/web-shared-components';
import React, { useState } from 'react';

import { InfoPrompt } from '@swf/first';

// TODO refactor to use composition or shared.scss
// eslint-disable-next-line no-restricted-imports
import { collapse, container } from '../../../BalanceRecord/BalanceRecord.scss';
import BalanceRecordItem from '../../../BalanceRecordItem/BalanceRecordItem';
import type { Props } from '../../OtherBalances';
// TODO refactor to use composition or shared.scss
// eslint-disable-next-line no-restricted-imports
import { recordTitle, recordTotal, separator } from '../../OtherBalances.scss';

import {
  TXTWCL_If_you_have_had_eChecks_return_ELL,
  TXTWCL_These_are_funds_from_eCheck_de_ELL,
  TXTWCL_Uncleared_funds
} from './UnclearedBalances.messages.json';

const UnclearedBalances: React.FC<Props> = ({ balances }) => {
  const [expand, setExpand] = useState(false);

  return (
    <>
      <div onClick={() => setExpand(!expand)}>
        <BalanceRecordItem
          className={recordTitle}
          label={<Translation {...TXTWCL_Uncleared_funds} />}
          expand={expand}
          isHeader
        />
      </div>
      <Collapse className={container} in={expand}>
        {balances.map(({ currency, unclearedForCashout }, index) => (
          <div key={currency} className={collapse}>
            {unclearedForCashout && (
              <BalanceRecordItem
                className={recordTotal}
                currency={currency}
                balance={unclearedForCashout}
                label={
                  <Translation {...TXTWCL_Uncleared_funds}>
                    {(translation) => (
                      <>
                        <span>{`${currency} - `}</span>
                        {translation}
                      </>
                    )}
                  </Translation>
                }
                info={
                  <InfoPrompt title={{ translation: TXTWCL_Uncleared_funds }} variant="wallet">
                    <Typography>
                      <Translation {...TXTWCL_These_are_funds_from_eCheck_de_ELL} />{' '}
                      <Translation {...TXTWCL_If_you_have_had_eChecks_return_ELL} />
                    </Typography>
                  </InfoPrompt>
                }
              />
            )}
            {balances.length - 1 > index && <div className={separator} />}
          </div>
        ))}
      </Collapse>
    </>
  );
};

export default UnclearedBalances;
